const organisations = {
  remove_organisation: 'Se déconnecter de cette organisation',
  share_contact_info: 'Partager vos informations de contact avec cette organisation',
  add_organisation: 'Se connecter à une organisation',
  delete_organisation_confirm: 'Êtes-vous certain de vouloir retirer cette organisation de votre liste?',
  click_to_add: 'Cliquer sur une organisation pour l\'ajouter à la liste de vos organisations',
};

export default organisations;
